import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';
import { shellLogoutAction } from '../../state/shell.actions';

@Component({
    template: ``,
    standalone: false
})
export class LogoutComponent implements OnInit {

    constructor(private store: Store<any>) {
    }

    ngOnInit(): void {
        this.store.dispatch(shellLogoutAction());
    }
}
